import { ParamIds, Places } from 'src/Constants'
import BorderoKeys from '../bordero.keys'

export class BorderoFormKeys extends BorderoKeys {
    get place() {
        return Places.mcBorderoForm
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcBorderoFormId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFormId, value)
    }
}
